"use strict";
// This is an autogenerated file. It should match the version number in package.json.
// Do not modify this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_VERSION = void 0;
exports.SDK_VERSION = "2.3.7";
//# sourceMappingURL=version.js.map